"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";
import { UserScriptModel } from "UserActionHandler/UserScriptModel";
/**
 * @module UserScriptFormFilterModel
 * @requires UserScriptModel
 * @exports UserScriptFormFilterModel
 */

/**
 * Class describes a form filter field behaviour.
 */

var UserScriptFormFilterField =
/*#__PURE__*/
function () {
  /**
   * @type {String}
   * @private
   */

  /**
   * @type {UserScriptFormFilterModel}
   * @private
   */

  /**
   * @type {Boolean}
   * @private
   */

  /**
   * @type {String}
   * @private
   */

  /**
   * @type {Object}
   * @private
   */

  /**
   * @param {UserScriptFormFilterModel} model
   * @param {string} name
   * @hideconstructor
   */
  function UserScriptFormFilterField(model, name) {
    _classCallCheck(this, UserScriptFormFilterField);

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_model", void 0);

    _defineProperty(this, "isTable", void 0);

    _defineProperty(this, "_valueField", void 0);

    _defineProperty(this, "_filter", void 0);

    this._name = name;
    this._model = model;
    this.isTable = !this._model._addFilter[name];

    if (!this.isTable) {
      this._filter = this._model._addFilter[this._name];
    } else {
      this._filter = this._model._getLSCol(this._name);
    }

    this._valueField = 'filterValue';
  }
  /** If the argument is passed then the function sets the value else it returns the value of the field.
   * @param {*} [value]
   * @return {*}
   * @example
   *  // if want to change operation in current table
   * SomeFieldChanged: (model) => {
   *     let AmountFld = fields.getFieldByName(Amount);
   *
   *     AmountFld.value(AmountFld.value() + 150);
   *
   *     return model;
   * }
   * @example
   * // if want to change operation in other table of current edit form
   * SomeFieldChanged: (model) => {
   *     let roleFieldRestrictionTable = model.getFieldByName('ADM_RoleFieldRestrictionList');
   *     let objectFieldFilter = roleFieldRestrictionTable.getFilterByName('Object');
   *
   *     objectFieldFilter.value('App_Cities');
   *
   *     return model;
   * }
   */


  _createClass(UserScriptFormFilterField, [{
    key: "value",
    value: function value(_value) {
      if (typeof _value !== "undefined") {
        this._filter[this._valueField] = _value;
      } else {
        return this._filter[this._valueField];
      }
    }
    /** If the argument is passed then the function sets the operation to the field else it returns the value of the field.
     * @param {String|undefined} [operation] Available operations: `['=' | '<>' | '<' | '>' | '<=' | '>=' | 'contains'| 'between' | 'isanyof' | 'isnotanyof' | 'isblank' | 'isnotblank']`
     * @return {String|undefined}
     * @example
     * // if want to change operation in current table
     * SomeFieldChanged: (model) => {
     *     let AmountFld = fields.getFieldByName(Amount);
     *
     *     AmountFld.operation('=');
     *
     *     return model;
     * }
     *
     * @example
     * // if want to change operation in other table of current edit form
     * SomeFieldChanged: (model) => {
     *     let roleFieldRestrictionTable = model.getFieldByName('ADM_RoleFieldRestrictionList');
     *     let objectFieldFilter = roleFieldRestrictionTable.getFilterByName('Object');
     *
     *     objectFieldFilter.operation('=');
     *
     *     return model;
     * }
     */

  }, {
    key: "operation",
    value: function operation(_operation) {
      if (typeof _operation !== "undefined") {
        this._filter.realOperation = _operation;
      } else {
        return this._filter.realOperation;
      }
    }
    /** Returns `true` if the field is a dictionary.
     * @return {boolean}
     * @example
     * SomeFieldChanged: function (model) {
     *     var AmountFld = model.getFieldByName(Amount);
     *
     *     if ( AmountFld.isDictionary()) {
     *         ...
     *     }
     *     return model;
     * }
     */

  }, {
    key: "isDictionary",
    value: function isDictionary() {
      return this._model._isLookup(this._name);
    }
  }]);

  return UserScriptFormFilterField;
}();

var UserScriptFormFilterModel =
/*#__PURE__*/
function () {
  /**
   * @param {Array} viewSource FormFilterFields
   * @param {Object} addFilter
   * @param {UserScriptModel} model
   * @param {Array} lsColumns
   * @param {Array} formFields FormFields
   * @hideconstructor
   */
  function UserScriptFormFilterModel(_ref) {
    var viewSource = _ref.viewSource,
        model = _ref.model,
        lsColumns = _ref.lsColumns,
        addFilter = _ref.addFilter,
        formFields = _ref.formFields;

    _classCallCheck(this, UserScriptFormFilterModel);

    _defineProperty(this, "_viewSource", []);

    _defineProperty(this, "_filter", {});

    _defineProperty(this, "_model", void 0);

    _defineProperty(this, "_lsColumns", []);

    _defineProperty(this, "_addFilter", []);

    _defineProperty(this, "_filterHash", void 0);

    _defineProperty(this, "_formFields", void 0);

    this._viewSource = viewSource;
    this._lsColumns = lsColumns;
    this._addFilter = addFilter;
    this._model = model;
    this._formFields = formFields;
    this.lsColumnsPrepare();
    this.addFilterPrepare();
    this._filterHash = JSON.stringify({
      lsColumns: this._lsColumns,
      addFilter: this._addFilter
    });
  }

  _createClass(UserScriptFormFilterModel, [{
    key: "_getTableFieldByObjID",
    value: function _getTableFieldByObjID(id) {
      return this._formFields.find(function (f) {
        return f[Fields.ObjectFieldID] === id;
      });
    }
  }, {
    key: "_getLinkedName",
    value: function _getLinkedName(field) {
      return this._getFromObjectField(field) ? field[Fields.ObjectFieldID_LinkedObjectID_Name] : field[Fields.LinkedObjectID_Name];
    }
  }, {
    key: "_getKeyObjFieldName",
    value: function _getKeyObjFieldName(field) {
      return this._getFromObjectField(field) ? field[Fields.ObjectFieldID_KeyObjectFieldID_Name] : field[Fields.LinkedObjectID_KeyObjectFieldID_Name];
    }
  }, {
    key: "_getDisplayObjectFieldIDName",
    value: function _getDisplayObjectFieldIDName(field) {
      return (this._getFromObjectField(field) ? field[Fields.ObjectFieldID_DisplayObjectFieldID_Name] : field[Fields.LinkedObjectID_DisplayObjectFieldID_Name]) || field[Fields.DisplayField];
    }
  }, {
    key: "_getObjectFieldType",
    value: function _getObjectFieldType(field) {
      var fieldType = this._getFromObjectField(field) ? field[Fields.ObjectFieldID_FieldType] : field[Fields.LinkedObjectID_DisplayObjectFieldID_FieldType];
      if (fieldType !== null) fieldType = field[Fields.FieldType];
      return fieldType;
    }
  }, {
    key: "_getFromObjectField",
    value: function _getFromObjectField(field) {
      return this._viewSource.some(function (item) {
        return item[Fields.ObjectFieldID] === field[Fields.ObjectFieldID];
      });
    }
  }, {
    key: "_isLookup",
    value: function _isLookup(dataField) {
      if (this._isTableField(dataField)) {
        var col = this._getLSCol(dataField);

        return col && col.IsLookup;
      }

      var field = this._viewSource.find(function (f) {
        return f.Name === dataField;
      });

      return this._getLinkedName(field) && this._getDisplayObjectFieldIDName(field);
    }
  }, {
    key: "_getLSCol",
    value: function _getLSCol(dataField) {
      return this._lsColumns.find(function (c) {
        return c.dataField === dataField;
      });
    }
  }, {
    key: "_isTableField",
    value: function _isTableField(dataField) {
      return this._model._addFilter[dataField] == null;
    }
    /**@description Returns an instance of UserScriptFormFilterField by name.
     * @param {String} name
     * @return {UserScriptFormFilterField}
     */

  }, {
    key: "getFilterByName",
    value: function getFilterByName(name) {
      return new UserScriptFormFilterField(this, name);
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      var addFilter = this._addFilter;
      var lsColumns = this._lsColumns;
      var obj = {
        lsColumns: lsColumns,
        addFilter: addFilter
      };
      return {
        isChanged: JSON.stringify(obj) !== this._filterHash,
        filter: obj,
        viewSource: this._viewSource
      };
    }
  }, {
    key: "addFilterPrepare",
    value: function addFilterPrepare() {
      var _this = this;

      this._viewSource.filter(function (f) {
        return !_this._getTableFieldByObjID(f.ObjectFieldID);
      }).forEach(function (f) {
        if (!_this._addFilter[f.Name]) {
          _this._addFilter[f.Name] = {
            realOperation: '=',
            filterValue: undefined
          };
        }
      });
    }
  }, {
    key: "lsColumnsPrepare",
    value: function lsColumnsPrepare() {
      var _this2 = this;

      if (!this._lsColumns.length) this._formFields.forEach(function (f) {
        if (!f.Name.includes(System.SYSTEM_PREFIX)) _this2._lsColumns.push({
          dataField: f.Name,
          realOperation: '=',
          filterValue: undefined
        });
      });
    }
  }, {
    key: "viewSource",
    get: function get() {
      return this._viewSource;
    }
  }]);

  return UserScriptFormFilterModel;
}();

export { UserScriptFormFilterModel as default };